import { Component, _decorator } from 'cc';
import DataType from '../../../../../tableEngine/Script/Game/Data/Config/DataStructure';

const { ccclass } = _decorator;

export enum BannerEventType {
    TURN = 'TURN',
}

@ccclass('BaseBanner')
export default abstract class BaseBanner extends Component {
    public static readonly EVENT_TYPE = BannerEventType;

    protected _canPlay: boolean = false;
    protected _interactable: boolean = false;

    public get blockTurning() {
        return this.shouldTurningBlocked();
    }

    public get canPlay() {
        return this._canPlay;
    }
    public set canPlay(value: boolean) {
        if (this._canPlay === value) {
            return;
        }
        this._canPlay = value;
        this.onCanPlayChanged();
    }

    public get interactable() {
        return this._interactable;
    }
    public set interactable(value: boolean) {
        if (this._interactable === value) {
            return;
        }
        this._interactable = value;
        this.onInteractableChanged();
    }

    public abstract display(data: DataType.Hall.BannerData): void;
    protected abstract shouldTurningBlocked(): boolean;
    protected abstract onCanPlayChanged(): void;
    protected abstract onInteractableChanged(): void;
}
